import { Grid, Stack } from '@mui/material';
import { FinalColor } from 'extract-colors/lib/types/Color';
import React, { useState } from 'react';

import type { ArtProject } from '../../../../utils/Types';
import { useParallax } from '../../../../utils/useParallax';

type Props = {
    project: ArtProject;
};

const ArtProjectCard = ({ project }: Props) => {
    const { cardRef, handleMouseMove, handleMouseLeave, getParallaxStyle } = useParallax();
    const [colors, setColors] = useState<FinalColor[]>();

    // useEffect(() => {
    //     extractColors(project.url, {
    //         pixels: 1130,
    //         distance: 0.15,
    //         splitPower: 15,
    //         lightnessDistance: 0,
    //         saturationDistance: 0,
    //         hueDistance: 0.3,
    //     }).then((c) => setColors(c.slice(0, 5)));
    // }, []);

    const renderPalette = () => {
        if (colors) {
            const SCALING_FACTOR = 0.06;
            const DEFAULT_SIZE = 35;

            const container = document.getElementById(
                `art-project-${project.title}`
            );
            const size = container
                ? container.clientWidth * SCALING_FACTOR
                : DEFAULT_SIZE;

            return colors.map((color: FinalColor, i) => {
                return (
                    <div
                        key={`art-project-${project.title}-colors-${i}`}
                        style={{
                            width: size,
                            height: size,
                            backgroundColor: color['hex'],
                        }}
                    />
                );
            });
        }

        return null;
    };

    return (
        <Grid size={6} onClick={() => (window.location.href = project.url)}>
            <div
                className="art-project-card"
                ref={cardRef}
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
                style={getParallaxStyle()}
            >
                <Stack spacing={1} className="art-project-card-overlay">
                    <h2>{project.title}</h2>
                    <label>
                        {project.medium.toString()}
                        {/* — {project.tools} */}
                    </label>
                </Stack>

                <img
                    id={`art-project-${project.title}`}
                    src={project.url}
                    alt={`${project.title}, ${project.medium}`}
                />

                <Stack
                    className="art-project-palette"
                    direction="row"
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                    }}
                >
                    {renderPalette()}
                </Stack>
            </div>
        </Grid>
    );
};

export default ArtProjectCard;
